__turbopack_context__.v({
  "actions": "_84SoSW_actions",
  "description": "_84SoSW_description",
  "detailsHeading": "_84SoSW_detailsHeading",
  "detailsPage": "_84SoSW_detailsPage",
  "infoBand": "_84SoSW_infoBand",
  "mainContent": "_84SoSW_mainContent",
});
